import "normalize.css";
import "amfe-flexible";
import "./style/theme.less";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/components/common";

import { NavBar, Icon, Row, Field, Button, Cell, CellGroup, Popup } from "vant";
Vue.use(NavBar)
  .use(Icon)
  .use(Row)
  .use(Field)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Popup);

import GPopup from "./components/common/GeneralPopup";
Vue.use(GPopup);

// import "./registerServiceWorker";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
